import { ExternalLink, Check } from "lucide-react";
import { openExternal } from "../../../services/nativeBrowser";

export interface PRRiskBrief {
  id: string;
  repo: string;
  prNumber: number;
  title: string;
  severity: "low" | "medium" | "high";
  agent?: string;
  rules: Array<{ id: string; summary: string }>;
  recommended: string[];
  htmlUrl: string;
  reviewed?: boolean;
}

interface Props {
  brief: PRRiskBrief;
  onMarkReviewed: (id: string) => void;
}

export function PRRiskBriefCard({ brief, onMarkReviewed }: Props) {
  const sevClass =
    brief.severity === "high" ? "is-deny" : brief.severity === "medium" ? "is-ask" : "is-allow";
  const hasRealUrl = typeof brief.htmlUrl === "string" && /^https?:\/\//i.test(brief.htmlUrl);
  return (
    <article className={`sr-brief ${brief.reviewed ? "is-reviewed" : ""}`}>
      <div className={`sr-brief__bar ${sevClass}`} />
      <div className="sr-brief__body">
        <div className="sr-brief__title">
          {brief.repo} #{brief.prNumber} · "{brief.title}"
        </div>
        <div className="sr-brief__meta">
          <strong>{brief.severity.toUpperCase()} RISK</strong>
          {" · "}
          {brief.rules.length} rules triggered
          {brief.agent && ` · ${brief.agent}-assisted`}
        </div>
        <div className="sr-brief__section">Triggered rules:</div>
        <ul className="sr-brief__list">
          {brief.rules.map((r) => (
            <li key={r.id}>
              <span className="sr-brief__rule-id">{r.id}</span> {r.summary}
            </li>
          ))}
        </ul>
        {brief.recommended.length > 0 && (
          <>
            <div className="sr-brief__section">Recommended actions:</div>
            <ol className="sr-brief__list">
              {brief.recommended.map((rec, i) => (
                <li key={i}>{rec}</li>
              ))}
            </ol>
          </>
        )}
        <div className="sr-brief__actions">
          {hasRealUrl ? (
            <button
              type="button"
              className="sr-btn sr-btn--ghost"
              onClick={() => void openExternal(brief.htmlUrl)}
            >
              <ExternalLink size={14} /> Open on GitHub
            </button>
          ) : (
            <button
              type="button"
              className="sr-btn sr-btn--ghost is-disabled"
              disabled
              title="No linked GitHub PR — this brief is from a local repo"
            >
              <ExternalLink size={14} /> Open on GitHub
            </button>
          )}
          {!brief.reviewed && (
            <button type="button" className="sr-btn" onClick={() => onMarkReviewed(brief.id)}>
              <Check size={14} /> Mark reviewed
            </button>
          )}
        </div>
      </div>
    </article>
  );
}
